
function findPath(obj, key, val, path = []) {
    if (obj[key] === val) {
        return path.concat(key);
    }

    for (let k in obj) {
        if (obj.hasOwnProperty(k) && typeof obj[k] === "object") {
            let nestedPath = findPath(obj[k], key, val, path.concat(k));
            if (nestedPath) {
                return nestedPath;
            }
        }
    }

    return null;
}

const GetTitleGuideline = (titleId) => {
    const titlePath = findPath(window.tgg.topics, "i", titleId.i);
    return {g: titlePath?.[0]};
};

const GetTggGuideline = (val) => {
    const guidelinePath = findPath(window.tgg.guidelines, "i", val.i);
    return {g: guidelinePath?.[0]};
};

function determineGuideline(result) {
    if (result.g === undefined) {
        if (result.t !== undefined) {
            return GetTggGuideline(result).g?.replace(/_/g, " ");
        } else {
            return GetTitleGuideline(result).g?.replace(/_/g, " ");
        }
    }
}


function determineTopicFile(guidelinePath, nextItem) {
    const topicsForGuideline = window.tgg.topics[guidelinePath];

    for (const [key, topic] of Object.entries(topicsForGuideline || [])) {
        if (topic.i === nextItem.i) {
            return key;
        }
    }

    return nextItem.i;
}

function findNestedObj(obj, key, val) {
    if (obj[key] === val) {
        return obj;
    }

    for (let k in obj) {
        if (obj.hasOwnProperty(k) && typeof obj[k] === "object") {
            let nestedObj = findNestedObj(obj[k], key, val);
            if (nestedObj) {
                return nestedObj;
            }
        }
    }

    return null;
}

const getTopicTitle = (topicId) => {
    try {
        return findNestedObj(window.tgg.topics, "i", topicId).s;
    } catch (error) {
        return "-Topic Title-";
    }
};


const getTitlePath = (titleId) => {
    // console.log(titleId);
    const titlePath = findPath(window.tgg.topics, "i", titleId);
    // console.log(titlePath);
    return titlePath[1];
}

export {
    GetTggGuideline,
    GetTitleGuideline,
    determineGuideline,
    determineTopicFile,
    getTopicTitle,
    getTitlePath
}